export default "__VITE_ASSET__BCbKyMRr__"